// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7cbabbfb","455":"6e30e0eb","977":"12627fa7"}[chunkId] + ".chunk.js";
};